import styled from "styled-components";
import { Row, Col, Grid } from "antd";
import { RAButtonPrimary, RATypography } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { RAImage } from "@/components/customs";
import { useTrackVisibility } from "react-intersection-observer-hook";

import Link from "next/link";
const { useBreakpoint } = Grid;
export function CareerProgram({ joining_our_team = {}, available_positions = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	return (
		<Container ref={ref}>
			<EachRow gutter={[60, 30]} align="middle">
				<Col
					xxl={{ span: 12 }}
					xl={{ span: 12 }}
					lg={{ span: 12 }}
					md={{ span: 24 }}
					sm={{ span: 24 }}
					xs={{ span: 24 }}
				>
					<Row
						style={{
							width: "100%",
							minHeight: "330px",
							position: "relative",
						}}
					>
						<Col span={24}>
							<RAImage
								url={joining_our_team?.photo || PATH_PUBLIC_IMAGES.journey_join_team}
								width="100%"
								height="100%"
								borderRadius="16px"
							/>
						</Col>
					</Row>
				</Col>
				<Col
					xxl={{ span: 12 }}
					xl={{ span: 12 }}
					lg={{ span: 12 }}
					md={{ span: 24 }}
					sm={{ span: 24 }}
					xs={{ span: 24 }}
				>
					<WrapperContent>
						<RATypography
							variant={screens?.xs ? "h4" : "h2"}
							style={{
								lineHeight: screens?.xs ? "24px" : "36px",
							}}
						>
							{joining_our_team?.title || ""}
						</RATypography>
					</WrapperContent>
					<RATypography variant="body3" bottom="30px" color="#595959">
						{joining_our_team?.description || ""}
					</RATypography>
				</Col>
			</EachRow>
			<EachRow style={{ animationDuration: "1.5s" }} gutter={[60, 30]} align="middle">
				<Col
					xxl={{ span: 12, order: 1 }}
					xl={{ span: 12, order: 1 }}
					lg={{ span: 12, order: 1 }}
					md={{ span: 24, order: 2 }}
					sm={{ span: 24, order: 2 }}
					xs={{ span: 24, order: 2 }}
				>
					<WrapperContent>
						<RATypography
							variant={screens?.xs ? "h4" : "h2"}
							style={{
								lineHeight: screens?.xs ? "24px" : "36px",
							}}
						>
							{available_positions?.title || ""}
						</RATypography>
					</WrapperContent>
					<RATypography variant="body3" bottom="30px" color="#595959">
						{available_positions?.description || ""}
					</RATypography>
					<div style={{ position: "absolute", padding: 2 }}>
						<div className="center">
							<button
								className="btn"
								onClick={() => window.open(available_positions?.button_link || "", "_blank")}
							>
								<svg width="235" height="51.5" viewBox="0 0 235 51.5" className="border">
									<rect x="1" y="1" width="233" height="50" rx="25" />
								</svg>
								<span>{available_positions?.button_content || ""}</span>
							</button>
						</div>
					</div>
				</Col>
				<Col
					xxl={{ span: 12, order: 2 }}
					xl={{ span: 12, order: 2 }}
					lg={{ span: 12, order: 2 }}
					md={{ span: 24, order: 1 }}
					sm={{ span: 24, order: 1 }}
					xs={{ span: 24, order: 1 }}
				>
					<Row
						style={{
							width: "100%",
							minHeight: "330px",
							position: "relative",
						}}
					>
						<Col span={24}>
							<RAImage
								url={available_positions?.photo || PATH_PUBLIC_IMAGES.journey_available_positions}
								width="100%"
								height="100%"
								borderRadius="16px"
							/>
						</Col>
					</Row>
				</Col>
			</EachRow>
		</Container>
	);
}

export function JoinOurTeam({ joining_our_team = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	return (
		<Container ref={ref}>
			<EachRow gutter={[{ xxl: 60, xl: 60, lg: 40, md: 0, sm: 0, xs: 0 }, 30]} align="middle">
				<Col
					xxl={{ span: 12 }}
					xl={{ span: 12 }}
					lg={{ span: 12 }}
					md={{ span: 24 }}
					sm={{ span: 24 }}
					xs={{ span: 24 }}
				>
					<Row
						style={{
							width: "100%",
							minHeight: "330px",
							position: "relative",
						}}
					>
						<Col span={24}>
							<RAImage
								url={joining_our_team?.photo || PATH_PUBLIC_IMAGES.journey_join_team}
								width="100%"
								height="100%"
								borderRadius="16px"
							/>
						</Col>
					</Row>
				</Col>
				<Col
					xxl={{ span: 12 }}
					xl={{ span: 12 }}
					lg={{ span: 12 }}
					md={{ span: 24 }}
					sm={{ span: 24 }}
					xs={{ span: 24 }}
				>
					<WrapperContent>
						<RATypography
							variant={screens?.xs ? "h4" : "h2"}
							style={{
								lineHeight: screens?.xs ? "24px" : "36px",
							}}
						>
							{joining_our_team?.title || ""}
						</RATypography>
					</WrapperContent>
					<RATypography variant="body3" bottom="30px" color="#595959">
						{joining_our_team?.description || ""}
					</RATypography>
				</Col>
			</EachRow>
		</Container>
	);
}

export function AvailablePositions({ available_positions = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	return (
		<Container ref={ref}>
			<EachRow gutter={[{ xxl: 60, xl: 60, lg: 40, md: 0, sm: 0, xs: 0 }, 30]} align="middle">
				<Col
					// style={{ paddingTop: "30px" }}
					xxl={{ span: 12, order: 1 }}
					xl={{ span: 12, order: 1 }}
					lg={{ span: 12, order: 1 }}
					md={{ span: 24, order: 2 }}
					sm={{ span: 24, order: 2 }}
					xs={{ span: 24, order: 2 }}
				>
					<WrapperContent>
						<RATypography
							variant={screens?.xs ? "h4" : "h2"}
							style={{
								lineHeight: screens?.xs ? "24px" : "36px",
							}}
						>
							{available_positions?.title || ""}
						</RATypography>
					</WrapperContent>
					<RATypography variant="body3" bottom="30px" color="#595959">
						{available_positions?.description || ""}
					</RATypography>
					<div style={{ position: "absolute", padding: 2 }}>
						<div className="center">
							<button
								className="btn"
								onClick={() => window.open(available_positions?.button_link || "", "_blank")}
							>
								<svg width="235" height="51.5" viewBox="0 0 235 51.5" className="border">
									<rect x="1" y="0.5" width="233" height="50" rx="25" />
								</svg>
								<span>{available_positions?.button_content || ""}</span>
							</button>
						</div>
					</div>
				</Col>
				<Col
					xxl={{ span: 12, order: 2 }}
					xl={{ span: 12, order: 2 }}
					lg={{ span: 12, order: 2 }}
					md={{ span: 24, order: 1 }}
					sm={{ span: 24, order: 1 }}
					xs={{ span: 24, order: 1 }}
				>
					<Row
						style={{
							width: "100%",
							minHeight: "330px",
							position: "relative",
						}}
					>
						<Col span={24}>
							<RAImage
								url={available_positions?.photo || PATH_PUBLIC_IMAGES.journey_available_positions}
								width="100%"
								height="100%"
								borderRadius="16px"
							/>
						</Col>
					</Row>
				</Col>
			</EachRow>
		</Container>
	);
}

const EachRow = styled(Row)``;
const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 60px;
	.center {
		width: 235px;
		height: 52px;
	}

	.btn {
		width: 235px;
		height: 52px;
		border-radius: 50px;
		cursor: pointer;
		background: transparent;
		border: 1px solid #ffb11a;
		outline: none;
		transition: 2s ease-in-out;
		box-sizing: border-box;
		position: relative;
	}

	svg {
		position: absolute;
		left: -1px;
		top: -1px;
		fill: none;
		stroke: #404040;
		stroke-dasharray: 100 560;
		stroke-dashoffset: 100;
		transition: 2s ease-in-out;
		z-index: 100;
		box-sizing: border-box;
	}

	.btn:hover {
		transition: 2s ease-in-out;
	}

	.btn:hover svg {
		stroke-dashoffset: -560;
	}

	.btn span {
		color: #222222;
		font-family: "DM Sans";
		font-weight: 500;
		font-size: 14px;
		/* line-height: 30px; */
		letter-spacing: 3px;
		text-transform: uppercase;
		text-indent: 3px;
	}
`;
const WrapperContent = styled.div`
	padding: 4px 12px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
	margin-bottom: 30px;
`;
